export default "__VITE_ASSET__BavKuU2w__"